import { Button, Drawer, DrawerProps, H3 } from '@blueprintjs/core'
import * as React from 'react'

export interface Props {
  drawerProps?: DrawerProps
  header: string
  isOpen: boolean
  onClear: () => void
  onClose?: (event?: React.SyntheticEvent<HTMLElement, Event>) => void
}

const FilterDrawer: React.FC<Props> = ({ children, header, onClose, onClear, isOpen, drawerProps = {} }) => {
  return (
    <Drawer hasBackdrop={false} size={365} onClose={onClose} isOpen={isOpen} {...drawerProps} className="filter-drawer">
      <div className="bp5-drawer-header">
        <H3>{header}</H3>
      </div>
      <div className="bp5-drawer-body">{children}</div>
      <div className="bp5-drawer-footer" style={{ display: 'flex' }}>
        <Button onClick={onClear}>Clear filters</Button>
        <Button style={{ marginLeft: '10px' }} onClick={onClose}>
          Close
        </Button>
      </div>
    </Drawer>
  )
}

export default FilterDrawer
